import React, { useContext } from 'react';
import { BrandProps, ClientConfig } from '../../../../clientConfig';
import { ClientConfigContext } from '../../../clientConfigContext';

export const AppPromImage = ({ brandInfo }: BrandProps) => {
    const clientConfiguration = useContext<ClientConfig>(ClientConfigContext);
    const cdnPath = clientConfiguration.cdnPath;

    return (
        <div className='promotionImageContainer'>
            <div className='promotionColorBlock' style={{ backgroundColor: brandInfo.promotion?.brandColor }}></div>
            <div className='promotionImage'>
                <img src={`${cdnPath}${brandInfo.promotion?.appImage}`} />
            </div>
        </div>
    );
};
